import { render, staticRenderFns } from "./ChooseVendorModal.vue?vue&type=template&id=407b9a22"
import script from "./ChooseVendorModal.vue?vue&type=script&lang=js"
export * from "./ChooseVendorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports